import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import {baseLineDataSelector, contentTableDataSelector, loadingSelector} from "@store/noc/threshold/selectors";

export function useThresholdData(getThresholdData: () => void) {
  const [baseLineData, setBaseLineData] = useState<Record<string, any>>([]);
  const [contentData, setContentData] = useState<Record<string, any>>([]);
  const baseLineTableData = useSelector(baseLineDataSelector) as Array<Record<string, any>>;
  const mainTableData = useSelector(contentTableDataSelector) as Array<Record<string, any>>;
  const reqState = useSelector(loadingSelector);

  useEffect(() => {
    getThresholdData();
  }, []);

  useEffect(() => {
    if (!reqState.loading) {
      setBaseLineData(baseLineTableData);
      setContentData(mainTableData);
    }
  }, [reqState.loading, baseLineTableData, mainTableData]);

  return {
    loading: reqState.loading,
    errorCode: reqState.errorCode,
    baseLineData,
    contentData
  }
}
